<black-accordion-header [title]="title" [expanded]="expanded" [index]="index" (deleteEvent)="dispatchDeleteEvent()" (toggleEvent)="dispatchToggleEvent()"></black-accordion-header>
